const About = () => {
  return (
    <section>
      <div className="container my-10 grid grid-cols-1 gap-8 lg:grid-cols-5">
        <div className="lg:col-span-4">
          <h2 className="mb-4 text-start text-3xl font-extrabold sm:text-4xl">Our Mission</h2>
          <div className="space-y-8 text-lg text-slate-500">
            <p className="max-w-prose text-start">
              The mission of this student activity is to develop the engineering students in various
              fields of technology through workshops, projects and competitions, to take out part in
              providing a generation capable of playing its roles effectively towards itself,
              community and country.
            </p>
            {/* <p className="max-w-prose text-start">
                We're constantly pushing the limits of what's possible in these competitions, and
                our innovative solutions have earned us recognition and accolades from industry
                experts and peers alike. But we're not just in it to win it. Our team is committed
                to using these competitions as a platform to advance the field of robotics and
                promote the development of new and innovative solutions.
              </p>
              <p className="max-w-prose text-start">
                We believe that by participating in these competitions, we can learn from our peers,
                share our knowledge, and push the boundaries of what's possible in this exciting
                field. So whether you're a student, a researcher, or simply someone who's interested
                in the cutting-edge of robotics, we invite you to join us on this exciting journey.
              </p> */}
          </div>
        </div>

        {/* <div>
            <dl className="mx-auto mt-10 flex flex-row justify-between gap-10 lg:flex-col">
              <div className="flex flex-col">
                <dt className="order-2 mt-2 text-lg font-medium leading-6 text-slate-500">
                  team members
                </dt>
                <dd className="order-1 text-5xl font-extrabold">98+</dd>
              </div>
              <div className="flex flex-col">
                <dt className="order-2 mt-2 text-lg font-medium leading-6 text-slate-500">
                  events and sessions
                </dt>
                <dd className="order-1 text-5xl font-extrabold">20+</dd>
              </div>
              <div className="flex flex-col">
                <dt className="order-2 mt-2 text-lg font-medium leading-6 text-slate-500">
                  Paid out to events
                </dt>
                <dd className="order-1 text-5xl font-extrabold">100k+</dd>
              </div>
            </dl>
          </div> */}
      </div>
    </section>
  );
};
export default About;
